import wxjs from 'weixin-js-sdk';

export const useWx = () => wxjs || window['wx' as any] as any;
